import { render, staticRenderFns } from "./SendErrorDialog.vue?vue&type=template&id=3d87b0ce&scoped=true"
import script from "./SendErrorDialog.vue?vue&type=script&lang=js"
export * from "./SendErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87b0ce",
  null
  
)

export default component.exports